'use strict';

/**
 * Collection for the imports
 *
 * @category   Collection
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollection = require('base/Colido.Collection');
var ImportModel = require('../models/import');

var ImportsCollection = ColidoCollection.extend({
    api: function() {
        var api = '/imports';

        if (this.catalog) {
            api =  this.catalog.api + '/' + this.catalog.id + '/imports';
        }

        return api;
    },

    getName: function() {
        var name = 'collection:imports';

        if (this.catalog) {
            name =  this.catalog.collection.name + ':' + this.catalog.id + ':imports';
        }

        return name;
    },

    name: 'collection:imports',

    model: ImportModel,

    sortDefault: 'id.desc',

    finishedStates: ['failed', 'complete'],

    unfinishedStates: ['queue', 'importing', 'processing', 'waiting'],

    initialize: function(models, options) {
        options = options || {};

        if (!options.catalog) {
            return Colido.config.debug && console.log('You have to provide a catalog model as option when initializing an imports collection');
        }

        this.catalog = options.catalog;

        this.name = this.getName();

        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },

    finished: function() {
        var finishedStates = this.finishedStates;

        return this.getFilteredCollection(function(model) {
            return _.contains(finishedStates, model.get('state'));
        });
    },

    unfinished: function() {
        var unfinishedStates = this.unfinishedStates;

        return this.getFilteredCollection(function(model) {
            return _.contains(unfinishedStates, model.get('state'));
        });
    },
});

module.exports = ImportsCollection;